// Доп. работы: `diagnosis` и `diagnost` — одинаковая роль диагноста.

const ROLES_MECHANIC_OR_DIAGNOST = ["mechanic", "diagnosis", "diagnost"];

function authorId(additionalWork) {
	return additionalWork?.mechanic?.id ?? null;
}

function isMechanicOrDiagnostic(userRole) {
	return ROLES_MECHANIC_OR_DIAGNOST.includes(userRole);
}

export function canCreateAdditionalWork(userRole) {
	return ["diagnost", "mechanic", "diagnosis", "admin"].includes(userRole);
}

export function canEditAdditionalWork(userRole, additionalWork, currentUserId) {
	if (!additionalWork) {
		return false;
	}
	if (userRole === "consultant" || userRole === "admin") {
		return true;
	}
	if (isMechanicOrDiagnostic(userRole)) {
		const aid = authorId(additionalWork);
		return aid != null && currentUserId != null && aid === currentUserId;
	}
	return false;
}

export function canDeleteAdditionalWork(userRole, additionalWork, currentUserId) {
	if (!additionalWork) {
		return false;
	}
	if (!isMechanicOrDiagnostic(userRole)) {
		return false;
	}
	const aid = authorId(additionalWork);
	return aid != null && currentUserId != null && aid === currentUserId;
}

export function canManageAdditionalWorkMedia(userRole, additionalWork, currentUserId) {
	return canEditAdditionalWork(userRole, additionalWork, currentUserId);
}
